<!--
 * @Author: your name
 * @Date: 2021-01-06 17:41:08
 * @LastEditTime: 2021-01-07 10:44:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\common\Executive.vue
-->
<template>
  <div id='executive'>
    <el-row class="addContact" v-if="roleType==3" @click.native="addExecutive">
      <i class="el-icon-plus"> 添加高管及其他任职信息</i>
    </el-row>
    <el-table :data="executiveData" stripe style="width: 100%" class="infoTableData">
      <el-table-column prop="executiveName" label="高管姓名">
      </el-table-column>
      <el-table-column prop="executivePosition" label="职位">
      </el-table-column>
      <el-table-column label="操作" v-if="roleType==3">
        <template slot-scope="scope">
          <span class="downLoad" @click="editExe(scope.row)">修 改</span>
          <span class="downLoad delete" @click="deleteExe(scope.row.id)">删 除</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="executiveCurrent" :current-page.sync="exeParams.pageNumber" :page-size="exeParams.pageSize" layout="total, prev, pager, next" :total="totalPage">
    </el-pagination>
    <!-- 添加高管及其他任职信息对话框 -->
    <el-dialog :title="exeFlag==1?'新增高管及其他任职信息':'修改高管及其他任职信息'" :visible.sync="executiveVisible" width="30%" custom-class="executiveVisible" @close="closeExeDialog">
      <el-form :model="executiveForm" :rules="executiveFormRules" ref="executiveForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="高管姓名:" prop="executiveName">
          <el-input v-model="executiveForm.executiveName"></el-input>
        </el-form-item>
        <el-form-item label="职位:" prop="executivePosition">
          <el-input v-model="executiveForm.executivePosition"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="addExeInfo">{{exeFlag==1?'新 增':'修 改'}}</span>
        <span class="button" @click="executiveVisible = false">取 消</span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { findExecutive, addOrUpdateExecutive, delExecutive } from '@/api/index'
export default {
  data() {
    return {
      userId: sessionStorage.getItem('userId'),
      roleType: window.sessionStorage.getItem('roleType'),
      executiveData: [],
      exeFlag: 1,
      executiveVisible: false,
      executiveForm: {
        id: '',
        executiveName: "",
        executivePosition: ''
      },
      executiveFormRules: {
        executiveName: [{ required: true, message: '请输入高管姓名', trigger: 'blur' }],
        executivePosition: [{ required: true, message: '请输入职位', trigger: 'blur' }]
      },
      exeParams: {
        userId: "",
        pageNumber: 1,
        pageSize: 5
      },
      totalPage: 0,
    }
  },
  created() {
    this.findExe()
  },
  methods: {
    async findExe() {
      if (this.roleType == 2 && this.$route.name == 'Management') {
        this.exeParams.userId = this.$route.query.id
      } else {
        this.exeParams.userId = this.userId
      }
      const { data } = await findExecutive(this.exeParams)
      if (data.code != 0) return
      this.executiveData = JSON.parse(JSON.stringify(data.executiveList))
      this.totalPage = data.total
    },
    addExecutive() {
      this.executiveVisible = true
      this.exeFlag = 1
    },
    addExeInfo() {
      this.$refs.executiveForm.validate(async valid => {
        if (valid) {
          const { data } = await addOrUpdateExecutive(this.executiveForm)
          if (data.code != 0) return
          this.executiveVisible = false
          this.findExe()
        }
      })
    },
    editExe(row) {
      this.exeFlag = 2
      this.executiveVisible = true
      this.executiveForm.id = row.id
      this.executiveForm.executiveName = row.executiveName
      this.executiveForm.executivePosition = row.executivePosition
    },
    deleteExe(id) {
      this.$confirm('确定删除当前数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async (res) => {
        if (res == 'confirm') {
          const { data } = await delExecutive(id)
          if (data.code !== 0) return
          this.findExe()
        }
      }).catch(() => {
        console.log('取消删除');
      });
    },
    closeExeDialog() {
      this.$refs.executiveForm.resetFields()
    },
    executiveCurrent(val) {
      this.exeParams.pageNumber = val
      this.findExe()
    },
  }
}
</script>
<style lang='less' scoped>
#executive {
  /deep/.executiveVisible {
    .el-input {
      width: 80%;
    }
    .el-input__inner {
      background: #fff;
    }
  }
}
</style>
